import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { AddAnalysisPage, findOcrWarningForSample, useOcrQueue } from '@practium/features/analyses';
import type { AnalysesTab } from '@practium/features/analyses';

export const AddAnalysisPageClient = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const [searchParams] = useSearchParams();
	const type = (searchParams.get('type') as AnalysesTab) || 'soil';
	const { getItem, remove, advanceSample } = useOcrQueue();
	const ocrItemId = (location.state as { ocrItemId?: string } | null)?.ocrItemId;
	const ocrItem = ocrItemId ? getItem(ocrItemId) : undefined;
	const currentOcrSample = ocrItem?.samples?.[ocrItem.sampleIndex];
	const currentOcrWarning = findOcrWarningForSample(ocrItem?.warnings, currentOcrSample);

	return (
		<AddAnalysisPage
			type={type}
			ocrSample={currentOcrSample}
			ocrFileKey={ocrItem ? ocrItem.id : undefined}
			ocrFileName={ocrItem?.fileName}
			ocrSampleIndex={ocrItem?.sampleIndex}
			ocrSampleTotal={ocrItem?.samples?.length}
			ocrWarning={!!currentOcrWarning}
			ocrWarningMessage={currentOcrWarning?.message}
			onOcrSaved={() => {
				if (!ocrItemId || !ocrItem) return false;
				if (advanceSample(ocrItemId)) return true;
				remove(ocrItemId);
				return false;
			}}
			onOcrCancelled={() => {
				if (ocrItemId) remove(ocrItemId);
			}}
			onBack={() => navigate('/analises')}
		/>
	);
};
